import { IndicatorType } from '../../constants/common'
import IndicatorBaseConfig from './indicatorBaseConfig'

export type Options = {
  period: number
}

export type Attrs = Options

export class AroConfig extends IndicatorBaseConfig {
  static type = IndicatorType.Aro
  static abbreviation = 'aro'
  static label = 'Aroon'
  static shortLabel = 'Aroon'
  static description =
    'Aroon is a technical indicator that measures trend strength and direction. It consists of two lines: Aroon Up and Aroon Down. When Aroon Up crosses above Aroon Down, it signals a potential uptrend, while the opposite indicates a potential downtrend. Divergence between Aroon and price can also suggest trend reversals.'

  static optionsOrder = ['period'] as const
  static optionsLabels = { period: 'Period' }
  static inputsOrder = this.optionsOrder
  static inputsLabels = this.optionsLabels
  static calculatedValuesOrder = ['aroonUp', 'aroonDown', 'oscillator'] as const
  static calculatedValuesLabels = {
    aroonUp: 'Aroon Up',
    aroonDown: 'Aroon Down',
    oscillator: 'Oscillator',
  }

  static defaultCalculatedValueOption = this.calculatedValuesOrder[0]
}
